var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCreation = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 32 32",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M25.334 1.333 23.654 5 20 6.667l3.654 1.68L25.334 12 27 8.347l3.667-1.68L27 5m-15 .333-3.333 7.334L1.334 16l7.333 3.333L12 26.667l3.334-7.334L22.666 16l-7.334-3.333m10 7.333-1.68 3.653L20 25.333 23.654 27l1.68 3.667L27 27l3.667-1.667L27 23.653"
})));
export default SvgCreation;